export default __webpack_public_path__ + "static/2024logo-365b7c5b43dbb44a07cf02207c6e4baf.jpg";